import { render } from "./HeroHome.vue?vue&type=template&id=5eaa9d62&scoped=true"
import script from "./HeroHome.vue?vue&type=script&lang=js"
export * from "./HeroHome.vue?vue&type=script&lang=js"

import "./HeroHome.vue?vue&type=style&index=0&id=5eaa9d62&lang=scss&scoped=true"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaa9d62"]])

export default __exports__